import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { DashboardLayout } from "@/components/layout/DashboardLayout";
import { UserTable } from "@/components/admin/users/UserTable";
import { toast } from "sonner";

const Users = () => {
  const { data: owners, isLoading, refetch } = useQuery({
    queryKey: ["owners"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("profiles")
        .select(`
          *,
          owner_data (
            company_name,
            business_type_id
          )
        `)
        .eq("user_type", "owner");

      if (error) throw error;
      return data;
    },
  });

  const handleBlockUser = async (userId: string, isBlocked: boolean) => {
    const { error } = await supabase
      .from("profiles")
      .update({ is_blocked: isBlocked })
      .eq("id", userId);

    if (error) {
      toast.error("Erreur lors de la mise à jour du statut de l'utilisateur");
      return;
    }

    toast.success(
      `Utilisateur ${isBlocked ? "bloqué" : "débloqué"} avec succès`
    );
    refetch();
  };

  return (
    <DashboardLayout userType="admin">
      <div className="container mx-auto p-6">
        <h1 className="text-2xl font-bold mb-6">Gestion des utilisateurs</h1>
        <UserTable
          owners={owners || []}
          isLoading={isLoading}
          onBlockUser={handleBlockUser}
        />
      </div>
    </DashboardLayout>
  );
};

export default Users;